const MARKETPLACE = {
  lazada: 'https://www.lazada.co.id/shop/haystyle',
  tokopedia: 'https://www.tokopedia.com/haystyle',
  shopee:
    'https://shopee.co.id/hay_sytleone',
};

export default MARKETPLACE;